export const contactList = {
	resumeTitle: 'Currículo',
	messageSend: 'Olá, você pode me ajudar?',
	cv: 'joaobru-pt.pdf',
};
